export enum Status {
  active = "active",
  inactive = "inactive",
  ready = "ready",
}
